import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import ptBr from './locale/pt_br';

Vue.use(Vuetify);
export default new Vuetify({
  lang: {
    locales: { ptBr },
    current: 'ptBr',
  },
  theme:
  {
    dark: false,
    themes: {
      light: {
        primary: '#03A9F4',
        secondary: '#212121',
        accent: '#B3E5FC',
        error: '#f44336',
        warning: '#ffeb3b',
        info: '#2196f3',
        success: '#4caf50'
      },
      dark: {
        primary: '#03A9F4',
        secondary: '#212121',
        accent: '#B3E5FC',
        error: '#f44336',
        warning: '#ffeb3b',
        info: '#2196f3',
        success: '#4caf50'
      }
    }
  },
  options: {
    customProperties: true
  },
  icons: {
    iconfont: 'md' // default is 'mdi'
  }
});
